/**
 * Get the element ID for the Uno main content element
 * @param appInstanceId ID of the Uno instance
 */ export function getUnoMainContentId(appInstanceId) {
    return `uno-main-content-${appInstanceId}`;
}
